import { AutogenModelDrsSettleHist, AutogenRowDrsSettleHist } from "./autogen/AutogenModelDrsSettleHist";

export class ModelDrsSettleHist extends AutogenModelDrsSettleHist<RowDrsSettleHist> {
	constructor() {
		super(RowDrsSettleHist);
	}
}

export class RowDrsSettleHist extends AutogenRowDrsSettleHist {
}